import PropTypes from 'prop-types';
import { createGoogleAPIFragment, STATIC_MARKER_URL, STATIC_OON_MARKER_URL } from "../../utils/StaticMap/constants";
import { styles } from "../../utils/StaticMap/mapScheme";
import { getStaticMapScheme, getMarkerScheme } from "../../utils/StaticMap";
import { jsx as _jsx } from "react/jsx-runtime";
const StaticMap = _ref => {
  let {
    latLng,
    // there are certain numbers here, check Google Static Map API
    scale = '1',
    scheme = styles,
    // there are certain numbers here, check Google Maps API
    zoom = '16',
    apiKey,
    providerLicensed = true,
    width = '470',
    height = '470'
  } = _ref;
  const {
    latitude,
    longitude
  } = latLng;
  // We determine which icon to use depending on the vendor's license.
  const iconUrl = providerLicensed ? STATIC_MARKER_URL : STATIC_OON_MARKER_URL;
  const apiUrl = createGoogleAPIFragment(apiKey);
  const center = `${latitude},${longitude}`;
  const markers = `&markers=${getMarkerScheme({
    center: `${center}`,
    icon: `${iconUrl}`,
    scale: `${scale}`
  })}`;
  const mapCenter = `&center=${center}`;
  const mapScale = `&scale=${scale}`;
  const mapScheme = `&${getStaticMapScheme(scheme)}`;
  const mapSize = `&size=${width}x${height}`;
  const mapZoom = `&zoom=${zoom}`;
  const mapSrc = `${apiUrl}${mapCenter}${markers}${mapScheme}${mapSize}${mapZoom}${mapScale}`;
  return /*#__PURE__*/_jsx("img", {
    alt: "map",
    src: mapSrc,
    width: width,
    height: height
  });
};
StaticMap.propTypes = {
  latLng: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  scale: PropTypes.string,
  scheme: PropTypes.array,
  size: PropTypes.string,
  apiKey: PropTypes.string.isRequired,
  zoom: PropTypes.string,
  providerLicensed: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string
};
StaticMap.defaultProps = {
  zoom: '16',
  providerLicensed: true,
  width: '470',
  height: '470'
};
export default StaticMap;
//# sourceMappingURL=StaticMap.js.map